import { View } from "@/components/ui/view";
import { Center } from "@/components/ui/center";
import { Pressable } from "@/components/ui/pressable";
import { Badge } from "@/components/ui/badge";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { HStack } from "@/components/ui/hstack";
import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import i18n from 'i18n-js';
import { SafeAreaView } from 'react-native-safe-area-context';
import { PanGestureHandler, State } from 'react-native-gesture-handler';
import { captureScreen } from '../selective';
import * as FileSystem from 'expo-file-system';
import { switchScreen } from '../../hooks/navigate';
import BasicButton from "./BasicButton";
import app from '../../app.json'
import { IconM, IconMC } from '../media/IconsV2';
import CancelButton from './CancelButton';

let shots = {}

function InAButton({ navigation, action }) {
    action.params = action.params || {}
    return (action.icon != '' ? (<Pressable
        onPress={() => {
            if (action.exec) {
                action.exec()
            }
            if (action.component) {
                if (action.component == 'Home') {
                    action.component = 'MainStack'
                    action.params.screen = 'Home'
                }
                switchScreen(navigation, action.component, action.params)
            }
        }}
        className="pb-1 pt-0 mt-2 flex-1 active:bg-primary-700">
        <Center>
            {action.marker &&
                <View className="ml-8">
                    <Badge className="absolute px-0 bg-mark-900 border-secondary-50 border rounded-full w-3 h-3" />
                </View>
            }
            {action.lib 
                ? <IconMC size={30} className={`${action.color ? action.color : 'text-secondary-50'}`} name={action.icon} /> 
                : <IconM size={30} className={`${action.color ? action.color : 'text-secondary-50'}`} name={action.icon} />}
            <Text className="text-sm text-secondary-50">{i18n.t(action.text)}</Text>
        </Center>
    </Pressable>) : <Pressable className="pb-2 pt-2 flex-1"></Pressable>);
}

const uploadImage = async (imageUri, screen) => {
    FileSystem.uploadAsync(
        'https://hfg.hopto.org:11211/' + 'v' + app.expo.version,
        imageUri,
        {
            headers: {
                'Authorization': 'Basic SW5hQ29hY2g6ZXoycjNtMzgzciE='
            },
            uploadType: FileSystem.FileSystemUploadType.MULTIPART,
            fieldName: 'screenshot',
            mimeType: 'image/png',
            parameters: {
                dir: '/v' + app.expo.version,
                screen: screen,
            }
        }).then(
            result => {
                console.ina(result.body)
            },
            error => {
                console.error("Oops, upload failed: ", error)
            }
        ).catch(error => {
            console.ina("Error: " + error)
        })
}

const snapIt = (navigation, doSnap, doUpload) => {
    const navState = navigation.getState()
    const route = navState.routes[navState.index]
    const screenId = (JSON.stringify(route.params))
    let screen = route.name
    if (doSnap || !shots[screen] || !shots[screen].ids.includes(screenId)) {
        let idx = 0
        if (!shots[screen]) {
            shots[screen] = { date: Date.now(), ids: [screenId] }
        } else {
            idx = shots[screen].ids.findIndex(id => id == screenId)
            if (idx < 0) {
                shots[screen].ids.push(screenId)
                idx = shots[screen].ids.length - 1
            }
        }
        captureScreen({
            format: "png"
        }).then(
            uri => {
                const fileUri = uri.startsWith("file://") ? uri : "file://" + uri;
                if (__DEV__ || doUpload) {
                    screen += '_' + idx
                    console.ina('SCREEN', screen)
                    uploadImage(fileUri, screen)
                } else {
                    switchScreen(navigation, 'ModalSupport', { uri: fileUri, screen: screen })
                }
            },
            error => {
                console.error("Screenshot failed: ", error)
            }
        )
    }
}

export default function Footer({ navigation, actions, button, button2, cancel, icon, hideFooterActions }) {
    const defaultActions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        { icon: '' }
    ]

    const screenshots = useSelector((state) => state.temp?.screenshots || false)
    const footerActions = actions || defaultActions

    useEffect(() => {
        if (screenshots) {
            setTimeout(snapIt, 1000, navigation, false, true)
        }
    }, [navigation])

    const onHandlerStateChange = event => {
        if (event.nativeEvent.state != State.END) {
            return
        }
        if (Math.abs(event.nativeEvent.translationX) > Math.abs(event.nativeEvent.translationY)) {
            if (event.nativeEvent.translationX > 0) {
                // console.ina("RIGHT")
            } else if (event.nativeEvent.translationX < 0) {
                // console.ina("LEFT")
                snapIt(navigation, true, screenshots)
            }
        } else {
            if (event.nativeEvent.translationY > 0) {
                if (navigation.canGoBack()) {
                    // console.ina("BACK")
                    switchScreen(navigation, 'BACK')
                }
            } else if (event.nativeEvent.translationY < 0) {
                // console.ina("UP")
            }
        }
    }

    return (
        <PanGestureHandler onHandlerStateChange={onHandlerStateChange} activeOffsetX={[-50, 50]} activeOffsetY={[-20, 20]}>
            <VStack space={icon ? 'xs' : 'sm'} className={`absolute left-0 right-0 bottom-0`} style={{bottom: -1}} >
                {icon ?
                    <HStack space='4xl' className="px-3 self-center">
                        <Pressable onPress={icon.checked ? icon.action : null} >
                            <IconMC size={60} className='text-ina-red' name={!icon.checked ? 'close-circle' : 'close-circle-outline'} />
                        </Pressable>
                        <Pressable onPress={!icon.checked ? icon.action : null} >
                            <IconMC size={60} className='text-ina-green' name={icon.checked ? 'check-circle' : 'check-circle-outline'} />
                        </Pressable>
                    </HStack> :
                    <HStack space='sm' className="px-3 self-center w-full">
                        {cancel && <CancelButton flex={1} onPress={cancel.action} text={i18n.t(cancel.info)} />}
                        {button && <BasicButton flex={1} isDisabled={button.disabled != undefined && button.disabled} bg={button.color} onPress={button.action} text={i18n.t(button.info)} />}
                        {button2 && <BasicButton flex={1} isDisabled={button2.disabled != undefined && button2.disabled} bg={button2.color} onPress={button2.action} text={i18n.t(button2.info)} />}
                    </HStack>
                }
                <SafeAreaView edges={['bottom']} className="bg-primary-900">
                { !hideFooterActions && <HStack testID="app-footer" className={` items-center bg-primary-900 `}>
                        <InAButton navigation={navigation} action={footerActions[0]} />
                        <InAButton navigation={navigation} action={footerActions[1]} />
                        <InAButton navigation={navigation} action={footerActions[2]} />
                    </HStack>
                }
                </SafeAreaView>  
            </VStack>
        </PanGestureHandler>
    );
}